module.exports = __webpack_public_path__ + "assets/images/warning.807eb39798ba56c71e4784a2e7a1a727.svg";